<div [formGroup]="form" *ngIf="form">
    <div class="row">
            <div class="form-group" class="col-lg-6">
                <label>{{'administration.sectionsManagement.code' | translate}} *</label>
                <apc-form-input [class]="'form-control'" formControlName="code"
                    type="text">
                </apc-form-input>
            </div>
        <div class="form-group" class="col-lg-6">
            <label>{{'administration.sectionsManagement.value' | translate}} *</label>
            <apc-form-input [class]="'form-control'" formControlName="name" type="text"></apc-form-input>
        </div>
    </div>
    <div class="row my-3">
        <div class="form-group" class='col-lg-6'>
            <label>{{'administration.sectionsManagement.category' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="category" type="text"></apc-form-input>
        </div>
        <div class="form-group" class='col-lg-6'>
            <label>{{'administration.sectionsManagement.productClass' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="productClass" type="text"></apc-form-input>
        </div>
    </div>
    <div class="row my-3">
        <div class="form-group" class='col-lg-6'>
            <label>{{'administration.sectionsManagement.unitOfMeasurement' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="unitOfMeasurement" type="text">
            </apc-form-input>
        </div>

        <div class="form-group" class='col-lg-6'>
            <label>{{'administration.sectionsManagement.macroCategory' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="macroCategory" type="text"></apc-form-input>
        </div>
    </div>
    <div class="row my-3">
        <div class="form-group" class='col-lg-6'>
            <label>{{'administration.sectionsManagement.group_1' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="group1" type="text">
            </apc-form-input>
        </div>
    </div>

    <div class="row my-3">
        <div class="form-group" class='col-lg-12'>
            <label>{{'administration.sectionsManagement.description' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="description" type="textarea"></apc-form-input>
        </div>
    </div>
</div>